/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { STATUS } from 'sarsaparilla';

import {
    FETCH_FACILITY_AVAILABILITY_SUCCESS,
    FETCH_FACILITY_AVAILABILITY_ERROR,
    SET_FETCH_FACILITY_AVAILABILITY_STATUS,
    RESET_FACILITY_AVAILABILITY,
} from '../actions/facilityAvailabilityActions';

export const initialState = {
    loadingStatus: STATUS.IDLE,
    lastFetched: {},
    isAvailableByDate: {},
    isSoldOutByDate: {},
    isFirstComeFirstServedByDate: {},
    isNotReleasedByDate: {},
    availableTourIdsByDate: {},
    notReleasedTourIdsByDate: {},
    firstComeFirstServedToursByDate: {},
    error: null,
    lastFetchedAccountType: '',
    nextReleaseByDate: {},
};

export const facilityAvailabilityReducers = (state = initialState, action) => {
    switch (action.type) {
        case SET_FETCH_FACILITY_AVAILABILITY_STATUS:
            return {
                ...state,
                loadingStatus: action.payload,
            };
        case FETCH_FACILITY_AVAILABILITY_SUCCESS:
            return {
                ...state,
                ...action.payload,
                nextReleaseByDate: {
                    ...state.nextReleaseByDate,
                    ...action.payload.nextReleaseByDate,
                },
                isLoading: false,
                loadingStatus: STATUS.SUCCESS,
                error: null,
            };
        case FETCH_FACILITY_AVAILABILITY_ERROR:
            return {
                ...state,
                error: action.payload,
                isLoading: false,
                loadingStatus: STATUS.ERROR,
            };
        case RESET_FACILITY_AVAILABILITY:
            return initialState;
        default:
            return state;
    }
};
